import { Link, Tooltip, Typography } from '@mui/material';
import { Stack } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import { dispatch, RootState } from 'store';
import { useCallback } from 'react';
import ConfirmationDialog from './dialog/ConfirmationDialog';
import AppNotification from 'sections/notifications/AppNotification';
import SettingsIcon from '@mui/icons-material/Settings';
import { showPageBlocker } from 'store/reducers/pageBlockerSlice';
import { useNavigate } from 'react-router';

interface Props {
  showLogoutConfirmation: boolean;
  setShowLogoutConfirmation: any;
  checkLogoutProcess: any;
  logoutInProgress: boolean;
}

const UserQuickActions = ({ showLogoutConfirmation, setShowLogoutConfirmation, checkLogoutProcess, logoutInProgress }: Props) => {
  const navigate = useNavigate();
  const decodedAuthToken = useSelector((state: RootState) => state.auth.decodedAuthToken);
  const isFormDirty = useSelector((state: RootState) => state.formslice.isDirty);
  const onLogout = useCallback(() => {
    setShowLogoutConfirmation(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const email = decodedAuthToken?.EmailId;
  const emailUsername = typeof email === 'string' && email.includes('@') ? email.split('@')[0] : '';

  return (
    <>
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Typography className="titleWelcome" sx={{ fontWeight: 400 }}>
          Welcome
        </Typography>
        <Typography className="titleWelcome" sx={{ fontWeight: 400 }}>
          {decodedAuthToken?.IsSaaS === 'True' ? emailUsername : decodedAuthToken?.unique_name}!
        </Typography>
        <AppNotification />
        <Link
          component="button"
          onClick={(e) => {
            if (isFormDirty) {
              e.preventDefault();
              dispatch(
                showPageBlocker({
                  onConfirm: () => (window.location.href = '/general-settings')
                })
              );
            } else {
              navigate('/general-settings');
            }
          }}
        >
          <Tooltip placement="top" title={'General Settings'}>
            <IconButton size="small">
              <SettingsIcon color="primary" className="breacrumbs-title-icons" />
            </IconButton>
          </Tooltip>
        </Link>
        <Tooltip placement="top" title={'Log Out'}>
          <IconButton size="small" onClick={onLogout}>
            <LogoutIcon color="primary" className="breacrumbs-title-icons" />
          </IconButton>
        </Tooltip>
      </Stack>
      <ConfirmationDialog
        open={showLogoutConfirmation}
        onClose={() => setShowLogoutConfirmation(false)}
        onConfirm={checkLogoutProcess}
        isLoading={logoutInProgress}
        message="Logout Confirmation"
        additionalContent={
          <Typography my={2} className="popup-description">
            Are you sure you want to logout?
          </Typography>
        }
        titleIconType="warning"
      />
    </>
  );
};

export default UserQuickActions;
